import { ApplicationRef, Component, inject, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FlowbiteService } from '../shared/services/flowbite.service';
import { LucideAngularModule } from 'lucide-angular';
import { ActivatedRoute } from '@angular/router';
import { UserDataService } from '../shared/services/userData.service';
import { FullCalendarModule } from '@fullcalendar/angular';
import { LargeSidebarComponent } from "./sidebar/large-sidebar/large-sidebar.component";
import { SmallSidebarComponent } from "./sidebar/small-sidebar/small-sidebar.component";
import { filter, map } from 'rxjs';
import { EopNavigationService } from '../shared/services/eopNavigation.service';
declare var initFlowbite: any;


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    LucideAngularModule,
    FullCalendarModule,
    LargeSidebarComponent,
    SmallSidebarComponent
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'REMs-EOP';
  userId: string | null = null;
  buildingId: string | null = null;
  sidebarStatus: string = '';
  showSidebar: boolean = true;
  private readonly activatedRoute = inject(ActivatedRoute);

  constructor(
    appRef: ApplicationRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    private flowbiteService: FlowbiteService,
    private router: Router,
    private userDataService: UserDataService,
    public eopNavigationService: EopNavigationService
  ) {
    // Optional: Monitor app stability
    // appRef.isStable.subscribe(stable => {
    //   console.log('App is stable?', stable);
    // });
  }

  ngOnInit(): void {
    this.flowbiteService.loadFlowbite(flowbite => {});

    // Sidebar visibility control
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let currentRoute = this.activatedRoute.root;
          while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
          }
          return currentRoute;
        }),
        map((route) => route.snapshot.data)
      )
      .subscribe((data) => {
        this.showSidebar = data['showSidebar'] !== false; // Set sidebar visibility based on route data
      });

    if (isPlatformBrowser(this.platformId)) {
      // Retrieve sidebar status from session storage
      const savedSidebarStatus = sessionStorage.getItem('sidebarStatus');
      this.sidebarStatus = savedSidebarStatus ? savedSidebarStatus : 'large';

      // Delay the Flowbite initialization to ensure the DOM is ready
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          setTimeout(() => {
            initFlowbite();
          }, 100);
        });
        
      if (localStorage.getItem("rems_eop_building_id")) { // get building Id from local storage
        this.buildingId = localStorage.getItem("rems_eop_building_id");
        this.userDataService.setBuildingId(this.buildingId + ""); // set building Id from local storage
      } else {
        this.activatedRoute.paramMap.subscribe((params) => {
          const buildingId = params.get('buildingId');
          if (buildingId) {
            this.userDataService.setBuildingId(buildingId);
          }
        });
      }
      if (this.buildingId) {
        this.eopNavigationService.loadTotalPages(this.buildingId);
      }
    }
  }

  toggleSidebarStatus(status: string): void {
    this.sidebarStatus = status;
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('sidebarStatus', status);
    }
  }
}
